
import {Service} from "@/services/Service";

export class PerfilPermisosService extends Service {
    constructor(axios) {
        super(axios, "/perfilp");
    }

    obtener(filtros) {
        this.onStart();

        return this.http.post(this.getUrl(['/obtener']), filtros)
            .then((response) => {
                return JSON.parse(response.data)
            })
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

    registro(params) {
        this.onStart();

        return this.http.post(this.getUrl(['/registro']), params)
            .then((response) => {
                // console.info("----", response.data);
                return JSON.parse(response.data)
            })
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

    eliminar(params) {
        this.onStart();

        return this.http.post(this.getUrl(['/eliminar']), params)
            .then((response) => {
                return JSON.parse(response.data)
            })
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

}